import { useSelector } from "react-redux";

export const usePaymentTermsLogic = () => {
  const dataSC = useSelector((state: any) => state.getSecData.value);

  //Destructure data
  const { payments = [] } = dataSC.secDataDetails.content;

  //Filter buyers with current >0 for multiple buyer case
  const validBuyers = payments.filter((buyer) => {
    if (Array.isArray(buyer.paymentTerms)) {
      const hasValidTerms = buyer.paymentTerms.some(
        (term) =>
          term.current !== null &&
          term.current !== undefined &&
          term?.current >= 0 &&
          term.with_incentive >= 0 &&
          term.without_incentive >= 0,
      );

      return hasValidTerms;
    } else if (buyer.paymentTerms) {
      const hasValidTerms =
        buyer.paymentTerms.current !== null &&
        buyer.paymentTerms.current !== undefined &&
        buyer.paymentTerms.current >= 0 &&
        buyer.paymentTerms.with_incentive >= 0 &&
        buyer.paymentTerms.without_incentive >= 0;
      return hasValidTerms;
    }
    return false;
  });

  const isPaymentTabVisible = validBuyers.length > 0;

  return {
    validBuyers,
    isPaymentTabVisible,
  };
};
